var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineTicketStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 20.75c-4.25 0-5.64-1.27-5.74-5.23 0-.2.07-.4.21-.54.14-.14.33-.23.54-.23 1.51 0 2.74-1.24 2.74-2.75S3.52 9.25 2.01 9.25c-.2 0-.39-.08-.54-.23a.7.7 0 0 1-.21-.54C1.36 4.52 2.75 3.25 7 3.25h10c4.41 0 5.75 1.34 5.75 5.75v6c0 4.41-1.34 5.75-5.75 5.75H7zm0-1.5h10c3.58 0 4.25-.68 4.25-4.25V9c0-3.57-.67-4.25-4.25-4.25H7c-3.18 0-4.04.54-4.21 3.07C4.76 8.2 6.25 9.93 6.25 12s-1.49 3.8-3.46 4.18c.17 2.54 1.03 3.07 4.21 3.07z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 7.5V4c0-.41.34-.75.75-.75s.75.34.75.75v3.5c0 .41-.34.75-.75.75s-.75-.34-.75-.75zM8.25 20v-3.5c0-.41.34-.75.75-.75s.75.34.75.75V20c0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.36 15.43c-.36-.26-.54-.7-.46-1.14l.21-1.19-.87-.85a1.17 1.17 0 0 1-.3-1.19c.14-.42.5-.73.94-.79l1.2-.18.54-1.09c.2-.4.6-.65 1.04-.65.45 0 .85.25 1.04.65l.54 1.09 1.2.18c.44.06.8.37.94.79.14.42.02.88-.3 1.19l-.87.85.21 1.19c.08.44-.1.88-.46 1.14-.36.26-.83.29-1.22.09l-1.07-.56-1.08.56a1.197 1.197 0 0 1-1.23-.09zm.92-3.28c.28.27.4.65.34 1.03l-.12.7.63-.33c.34-.18.74-.18 1.08 0l.63.33-.12-.7c-.06-.39.06-.77.34-1.03l.51-.5-.7-.1c-.38-.06-.71-.3-.88-.64l-.31-.64-.31.64c-.17.34-.5.58-.88.64l-.72.1.51.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineTicketStar);
export default __webpack_public_path__ + "static/media/vuesax-outline-ticket-star.5a7d7bb6d4ce110d09b1501568d42af9.svg";
export { ForwardRef as ReactComponent };